<div class="container text_detalle">
    <!-- Template de loading global -->
    <ng-template #loading>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>

    <!-- Header Section -->
    <div class="header" *ngIf="materia$ | async as materiaCursoPeriodo; else loading">
        <!-- <div>{{materiaNombre}}</div><br> -->
        <div class="teachers-section">
            <h5 class="section-title">{{ materiaCursoPeriodo.nombre }}</h5>
            <div class="teachers-list">
                <div class="teacher-card" *ngFor="let profesor of materiaCursoPeriodo.profesores">
                    <div class="teacher-info">
                        <strong class="teacher-name">{{ profesor.nombresApellidos }}</strong>
                        <span class="teacher-email">{{ profesor.eMail }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="tools-section">
            <!-- Date Picker -->
            <div class="date-picker">
                <mat-form-field *ngIf="calendarData$ | async as calendarData; else loading" appearance="outline"
                    class="full-width">
                    <mat-label>Fecha</mat-label>
                    <input matInput [matDatepicker]="picker" (dateChange)="changeDate($event.value)"
                        [formControl]="date" [min]="calendarData.initialDate" [max]="calendarData.endDate"
                        placeholder="Elegir fecha" />
                    <mat-datepicker-toggle matSuffix [for]="picker">
                        <mat-icon matDatepickerToggleIcon [matBadge]="calendarData.listPendientes.length"
                            matBadgeColor="warn" aria-hidden="false">event</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker [dateClass]="dateClass(calendarData.listPendientes)">
                    </mat-datepicker>
                </mat-form-field>
            </div>

            <!-- Hours Counter -->
            <div class="hours-counter">
                <mat-form-field appearance="outline" class="counter-field">
                    <mat-label>Horas</mat-label>
                    <input matInput [(ngModel)]="materiaCursoPeriodo.horasClase" disabled />
                </mat-form-field>
                <div class="counter-actions">
                    <button color="primary" mat-icon-button (click)="addHour(materiaCursoPeriodo)">
                        <mat-icon>add</mat-icon>
                    </button>
                    <button color="primary" mat-icon-button (click)="removeHour(materiaCursoPeriodo)"
                        [disabled]="materiaCursoPeriodo.horasClase == 0">
                        <mat-icon>remove</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Student Table Section -->
    <div class="table-container">
        <div class="table-filters">
            <mat-form-field appearance="outline" class="search-field">
                <mat-label>Filtrar por nombre</mat-label>
                <input matInput placeholder="Filtrar por nombre" (keyup)="filtroTexto($event.target.value)"
                    autocomplete="off" />
            </mat-form-field>

            <mat-slide-toggle color="primary" (change)="toggleRowsState($event)" [checked]="true">
                {{ (rowStateAction$ | async)?.label }}
            </mat-slide-toggle>
        </div>

        <mat-table #table [dataSource]="filteredStudents$ | async" multiTemplateDataRows matSort class="student-table">
            <!-- Student Column -->
            <ng-container matColumnDef="Alumno">
                <mat-header-cell *matHeaderCellDef> Alumno </mat-header-cell>
                <mat-cell *matCellDef="let element" style="padding: 8px">
                    <div style="display: flex; flex-direction: column; height: 100%">
                        <div class="student-info">
                            <div class="student-avatar">
                                <img src="{{ element.alumno.imageUrl }}" alt="Foto del alumno" />
                            </div>
                            <div class="student-details">
                                <strong>{{ element.alumno.apellidosNombres }}</strong>
                            </div>
                            <ng-container *ngIf="(rowStateAction$ | async)?.state === 'collapsed'">
                                <div class="attendance-badges">
                                    <span class="attendance-badge" *ngFor="let asistencia of element.asistencias"
                                        [class.retardo]="(tiposAsistencia | filtroID: asistencia.tipoID).codigo.indexOf('R') > -1"
                                        [class.ausencia]="(tiposAsistencia | filtroID: asistencia.tipoID).codigo.indexOf('A') > -1">
                                        {{ (tiposAsistencia | filtroID: asistencia.tipoID).codigo }}
                                    </span>
                                </div>
                            </ng-container>
                        </div>

                        <!-- Novedades Section -->
                        <div class="student-detail" [@detailExpand]="(rowStateAction$ | async)?.state">
                            <div class="detail-section">
                                <h4><strong>Novedades</strong></h4>
                                <div class="attendance-info">
                                    <span class="attendance-badge" *ngIf="element.asistenciaGeneral" [class.retardo]="
                      (tiposAsistencia | filtroID: element.asistenciaGeneral.tipoID).codigo.indexOf('R') > -1
                    " [class.ausencia]="
                      (tiposAsistencia | filtroID: element.asistenciaGeneral.tipoID).codigo.indexOf('A') > -1
                    " [class.en-casa]="
                      (tiposAsistencia | filtroID: element.asistenciaGeneral.tipoID).codigo.indexOf('PC') > -1
                    ">
                                        {{ (tiposAsistencia | filtroID: element.asistenciaGeneral.tipoID).codigo }}
                                    </span>
                                    <span class="permiso-badge" *ngIf="
                      element.asistenciaGeneral &&
                      element.asistenciaGeneral.isPermiso &&
                      element.asistenciaGeneral.tipoID !== 12
                    ">
                                        Pe
                                    </span>
                                    <span class="comment">
                                        {{ element.asistenciaGeneral ? element.asistenciaGeneral.comentario : '' }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-cell>
            </ng-container>

            <!-- Accumulated Tasks Column -->
            <!-- <ng-container matColumnDef="TareasAcumuladas">
                <mat-header-cell *matHeaderCellDef class="mobile-hidden"> Tareas acumuladas </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mobile-hidden" style="padding: 8px">
                    <div style="display: flex; flex-direction: column; height: 100%">
                        <div #tareaContenedor>
                            <button mat-icon-button [disabled]="element.faltaTareaAcumula === 0" [disableRipple]="true"
                                (click)="$event.preventDefault(); $event.stopPropagation(); getDetalleTareas(element.alumno, tareaContenedor)">
                                <span class="badge-circle" *ngIf="element.faltaTareaAcumula > 0">
                                    {{ element.faltaTareaAcumula }}
                                </span>
                            </button>
                        </div>
                        <div class="student-detail" [@detailExpand]="(rowStateAction$ | async)?.state">
                            <div class="detail-section task-section">
                                <h4>
                                    <mat-checkbox color="primary" (change)="setTareaState($event, element)"
                                        [checked]="element.faltaTarea && element.faltaTarea.faltaTarea"
                                        [value]="element">
                                        <strong>Falta tarea</strong>
                                    </mat-checkbox>
                                </h4>

                                <mat-form-field appearance="outline" class="full-width"
                                    *ngIf="element.faltaTarea && element.faltaTarea.id > 0; else disabledTextarea">
                                    <mat-label>Observación por tarea</mat-label>
                                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                        cdkAutosizeMinRows="1" cdkAutosizeMaxRows="3"
                                        (keyup)="setComment($event.target.value, element)"
                                        [value]="element.faltaTarea.comentario"></textarea>
                                </mat-form-field>
                                <ng-template #disabledTextarea>
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Observación por tarea</mat-label>
                                        <textarea matInput cdkTextareaAutosize disabled></textarea>
                                    </mat-form-field>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </mat-cell>
            </ng-container> -->

            <!-- Accumulated Absences Column -->
            <ng-container matColumnDef="AusenciasAcumuladas">
                <mat-header-cell *matHeaderCellDef class="mobile-hidden"> Ausencias acumuladas </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mobile-hidden" style="padding: 8px">
                    <div style="display: flex; flex-direction: column; height: 100%">
                        <div class="absence-container" #asistenciaDetalle>
                            <button mat-icon-button [disabled]="element.ausencias === 0" [disableRipple]="true"
                                (click)="detallesAsistencia(element, asistenciaDetalle)">
                                <span class="badge-circle" *ngIf="element.ausencias > 0"> {{ element.ausencias }}
                                </span>
                            </button>
                        </div>
                        <mat-icon *ngIf="element.isAusenciaConsecutiva" color="warn"
                            matTooltip="Tres o más ausencias consecutivas">warning</mat-icon>

                        <div class="student-detail" [@detailExpand]="(rowStateAction$ | async)?.state">
                            <!-- Asistencia Section -->
                            <div class="detail-section">
                                <div class="attendance-header">
                                    <h4><strong>Asistencia</strong></h4>
                                    <div
                                        *ngIf="element.asistencias.length > 0 && existsAssistance(element.asistencias)">
                                        <button mat-icon-button (click)="openComments(element.asistencias[0])"
                                            [matTooltip]="element.asistencias[0].comentario">
                                            <mat-icon>message</mat-icon>
                                        </button>
                                    </div>
                                    <span class="hours-count">{{ element.asistencias.length }} hora{{
                                        element.asistencias.length === 1 ? '' : 's'
                                        }}
                                        de clase</span>
                                </div>

                                <div class="attendance-blocks">
                                    <ng-container *ngFor="let asistencia of element.asistencias; index as i">
                                        <div class="attendance-block" [matMenuTriggerFor]="menu"
                                            [class.present]="(tiposAsistencia | filtroID: asistencia.tipoID).codigo.indexOf('P') > -1"
                                            [class.retardo]="(tiposAsistencia | filtroID: asistencia.tipoID).codigo.indexOf('R') > -1"
                                            [class.ausencia]="(tiposAsistencia | filtroID: asistencia.tipoID).codigo.indexOf('A') > -1"
                                            [class.en-casa]="(tiposAsistencia | filtroID: asistencia.tipoID).codigo.indexOf('PC') > -1">
                                            <span class="attendance-type">
                                                {{ (tiposAsistencia | filtroID: asistencia.tipoID).codigo || 'P' }}
                                            </span>
                                            <span class="hour-label">Hora {{ i + 1 }}</span>
                                        </div>

                                        <mat-menu #menu="matMenu">
                                            <ng-container
                                                *ngFor="let itemAsistencia of tiposAsistencia | tiposAsistencia: ['P']">
                                                <button mat-menu-item
                                                    (click)="setAsistencia(itemAsistencia, asistencia)">
                                                    {{ itemAsistencia.nombre }}
                                                </button>
                                            </ng-container>
                                            <button mat-menu-item [matMenuTriggerFor]="menuAusencia">Ausencia</button>
                                            <button mat-menu-item [matMenuTriggerFor]="menuRetardos">Retardo</button>
                                        </mat-menu>

                                        <mat-menu #menuAusencia="matMenu">
                                            <ng-container
                                                *ngFor="let itemAsistencia of tiposAsistencia | tiposAsistencia: ['A', 'A0', 'A1', 'A2', 'A3']">
                                                <button mat-menu-item
                                                    (click)="setAsistencia(itemAsistencia, asistencia)">
                                                    {{ itemAsistencia.nombre }}
                                                </button>
                                            </ng-container>
                                        </mat-menu>

                                        <mat-menu #menuRetardos="matMenu">
                                            <ng-container
                                                *ngFor="let itemAsistencia of tiposAsistencia | tiposAsistencia: ['R', 'R0', 'R1', 'R2', 'R3']">
                                                <button mat-menu-item
                                                    (click)="setAsistencia(itemAsistencia, asistencia)">
                                                    {{ itemAsistencia.nombre }}
                                                </button>
                                            </ng-container>
                                        </mat-menu>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-cell>
            </ng-container>

            <!-- Expanded Row Details -->
            <ng-container matColumnDef="expandedDetail">
                <mat-cell *matCellDef="let element" [attr.colspan]="3"> </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let element; columns: displayedColumns" class="student-row"
                [class.expanded-row]="expandedElement === element"></mat-row>
            <mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></mat-row>
        </mat-table>
    </div>
</div>
